/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, BoxView, Text, Avatar, ActionButton, Button } from '@components/atoms'
import { Grid } from '@grid'
import { adminUsersColumns } from '@grid'

import { useNavigate } from 'react-router-dom'
import {
	useAppSelector,
	useAppDispatch,
	adminUsersActions,
	ApiGetDataStatus,
} from '@redux/index'
import { UserType } from '@schemas'
import { GridRowModel, GridRenderCellParams } from '@mui/x-data-grid'

const AdminUsersPage = () => {
	const reduxDispatch = useAppDispatch()

	const navigate = useNavigate()

	// redux state
	const userList: UserType[] = useAppSelector(state => state.adminUsers.userList)
	const status: ApiGetDataStatus = useAppSelector(
		state => state.adminUsers.userListStatus,
	)

	const onAction = (iudFlag: string, aRow: GridRowModel) => {
		const newData = {
			iudFlag: iudFlag,
			id: aRow.id,
			name: aRow.name,
			email: aRow.email,
			language: aRow.language,
			useYn: aRow.useYn,
		}
		reduxDispatch(adminUsersActions.UPDATE_USER({ ...newData }))
	}

	return (
		<View css={style}>
			<BoxView title="사용자 관리">
				<Grid
					title="사용자 관리"
					rows={userList}
					columns={adminUsersColumns}
					loading={status === 'loading'}
					onAction={onAction}
					renderCell={{
						avata: (
							params: GridRenderCellParams<
								{ id: string; name: string; color: string; imageUrl: string },
								any,
								any
							>,
						) => {
							if (params.value === null) {
								return <></>
							}

							return (
								<Avatar
									picture={params.value.imageUrl}
									name={params.value.name}
									color={params.value.color}
									size={28}
								/>
							)
						},
						password: () => {
							return <Text>********</Text>
						},
					}}
					/* 아바타·패스워드는 "입력"이 아니라 "버튼"이다. renderEditCell 에 두면
					   MUI 셀 편집 상태에 걸려 해당 셀을 더블클릭해야 나온다 —
					   수정 모드를 켜는 순간 바로 보이도록 renderEditModeCell 로 옮겼다. */
					renderEditModeCell={{
						avata: (params: GridRenderCellParams) => {
							const onEditClick = () => {
								reduxDispatch(
									adminUsersActions.EDIT_USER_PROFILE_IMAGE({ id: params.value.id }),
								)
							}

							return (
								<View style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
									<Avatar
										picture={params.value.imageUrl}
										name={params.value.name}
										color={params.value.color}
										size={28}
									/>

									<ActionButton
										iconName="cog"
										tooltip="이미지 변경"
										onClick={onEditClick}
									/>
								</View>
							)
						},
						password: (params: GridRenderCellParams) => {
							const onClick = () => {
								navigate('/admin/reset-password')
								reduxDispatch(adminUsersActions.EDIT_UPASSWORD_USER({ ...params.value }))
							}

							if (params.row.isNew) {
								return <></>
							}

							return (
								<Button variant="outlined" size="small" onClick={onClick}>
									수정
								</Button>
							)
						},
					}}
				/>
			</BoxView>
		</View>
	)
}

export default AdminUsersPage

const style = css({ height: '100%' })
